/* eslint-disable react/display-name */
import {
  setValueAction,
  valueSelector,
  ValueType,
} from '@smartsheet-dataflow/formjs';
import { EntityId } from '@smartsheet-dataflow/formjs-react';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PartialBy } from '../../../utils/types';

interface WithFormJSValueProps {
  value: ValueType;
  onChange: (value?: any) => void;
}

export const withFormJSValue =
  <P extends EntityId & WithFormJSValueProps>(
    Component: React.ComponentType<P>
  ) =>
  (props: PartialBy<P, 'value' | 'onChange'>) => {
    const value = useSelector(valueSelector(props.id));
    const dispatch = useDispatch();
    const setValue = setValueAction(dispatch);
    const onChange = useCallback(
      newValue => setValue({ inputId: props.id, value: newValue }),
      [props.id, setValue]
    );
    return <Component {...(props as P)} value={value} onChange={onChange} />;
  };
